import { setElementHtml } from '@local_modules/generic/dom/set-element-html.js'
import { checkPageRestriction } from '../../../helpers/restrictions/check-page-restriction.js'
import { applyRestrictions } from '../../../modules/user/html-parser.js'
import { showCreateAccountForm } from './create/index.js'

import htmlTemplateIndex from './index.html'
import { showUserAccounts } from './list/index.js'

export async function showPageUserAccounts (params) {
  console.log('showPageUserAccounts()')
  const { containerElementId, browserAppUser } = params

  if (!checkPageRestriction({ browserAppUser, allowNoAccount: true })) return

  // Prepare the html
  const appUserData = browserAppUser.data
  let htmlIndex = htmlTemplateIndex
  htmlIndex = applyRestrictions(htmlIndex, { userData: appUserData.appUser })

  // Inject in the page
  const moduleElement = setElementHtml(containerElementId, htmlIndex)

  // Set page title
  document.title = ['Your Accounts'].join(' ')

  // Additional
  showCreateAccountForm('formCreateAccount', moduleElement)
  showUserAccounts('userAccounts')

  // Listeners
  moduleElement.addEventListener('userAccountCreated', function () {
    showUserAccounts('userAccounts')
  })
}
